<app-navbar-style-one></app-navbar-style-one>

<div class="custom-page-header-section">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>about us</h2>
                    <p class="mt-4 mb-0 mx-3">we believe great food brings people together. That’s why we serve pizzas baked to perfection, burgers stacked with flavor, crispy chicken, and refreshing drinks — all made with fresh ingredients and a whole lot of love. Whether you’re dining in, taking out, or ordering delivery, we’re here to make every bite delicious.”</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/home2/about.jpg" alt="Menu Page" class="img-fluid">
            </div>
        </div>
    </div>
</div>

<section class="aboutSection mt-5 mb-3">
    <div class="container-fluid px-4">
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="make-special">What Makes Us Special</h2>
                <p class="make-special-paragraph">Your Meal… Just the Way You Love It!</p>
            </div>
            <div class="col-12 mt-2">
                <div class="row">
                    <div class="col-md-6 menu-header-section mt-3">
                        <h2 class="currentRoute">With us, you’re the chef</h2>
                        <p class="paragraph">{{aboutContent}}</p>
                    </div>
                    <div class="col-md-6 mt-5 items text-end before-img-section">
                        <img [src]="aboutImage" class="itemImage" alt="About">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="aboutSection mt-5 mb-3">
    <div class="container-fluid px-4">
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="make-special">Our story</h2>
                <p class="make-special-paragraph">Every bite is made to make you smile</p>
            </div>
            <div class="col-12 mt-2">
                <div class="row our-story-section">
                    <div class="col-md-8 menu-header-section mt-3">
                        <div class="row align-items-center justify-content-center mt-3">
                            <div class="col-lg-4 col-md-6">
                                <span>🍴Started with passion</span>
                            </div>
                            <div class="col-lg-8 col-md-6">
                                <ul class="mb-0">
                                    <li>A love for good food and sharing it with others.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row align-items-center justify-content-center mt-3">
                            <div class="col-lg-4 col-md-6">
                                <span>🍕 Freshly made always</span>
                            </div>
                            <div class="col-lg-8 col-md-6">
                                <ul class="mb-0">
                                    <li>Every pizza, burger, and chicken meal is prepared from quality ingredients.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row align-items-center justify-content-center mt-3">
                            <div class="col-lg-4 col-md-6">
                                <span>👨‍🍳 Your choice, your taste</span>
                            </div>
                            <div class="col-lg-8 col-md-6">
                                <ul class="mb-0">
                                    <li> From customizing your pizza to building your perfect burger.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row align-items-center justify-content-center mt-3">
                            <div class="col-lg-4 col-md-6">
                                <span>🤝 Bringing people together</span>
                            </div>
                            <div class="col-lg-8 col-md-6">
                                <ul class="mb-0">
                                    <li>Meals designed to make family and friends gather around the table.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row align-items-center justify-content-center mt-3">
                            <div class="col-lg-4 col-md-6">
                                <span>🚀 Always growing</span>
                            </div>
                            <div class="col-lg-8 col-md-6">
                                <ul class="mb-0">
                                    <li>From our first recipe to today, we keep improving to serve you better.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mt-5 items text-center before-img-section">
                        <img src="../../../assets/img/home2/about2.png" class="itemImage" alt="About">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="aboutSection mt-5 mb-3">
    <div class="container-fluid px-4">
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="make-special">Our Values</h2>
                <!-- <p class="make-special-paragraph">Every bite is made to make you smile</p> -->
            </div>
            <div class="col-12 mt-2">
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="about-icons-section">
                            <span class="about-icons m-auto">
                                <img src="../../../assets/img/home2/tea-pot.png" class="itemImage" alt="About">
                            </span>
                        </div>
                        <div class="icons-description">
                            <p class="title">Fresh Ingredients</p>
                            <p class="description">We source only the finest, freshest ingredients daily. From vine-ripened tomatoes to premium cheese, we ensure every slice is packed with authentic flavor.</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="about-icons-section">
                            <span class="about-icons m-auto">
                                <img src="../../../assets/img/home2/juice.png" style="width: 60%;" class="itemImage" alt="About">
                            </span>
                        </div>
                        <div class="icons-description">
                            <p class="title">Made to Order</p>
                            <p class="description">Every meal is freshly prepared exactly when you order it, ensuring it reaches you piping hot and full of flavor.</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="about-icons-section">
                            <span class="about-icons m-auto">
                                <img src="../../../assets/img/home2/coffee-shop.png" class="itemImage" alt="About">
                            </span>
                        </div>
                        <div class="icons-description">
                            <p class="title">Takeaway & Delivery</p>
                            <p class="description">Enjoy your favorite food wherever you are. We offer fast, reliable delivery and easy takeaway options to fit your schedule.</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="about-icons-section">
                            <span class="about-icons m-auto">
                                <img src="../../../assets/img/home2/doughnut.png" class="itemImage" alt="About">
                            </span>
                        </div>
                        <div class="icons-description">
                            <p class="title">Customer First</p>
                            <p class="description">Your satisfaction is our top priority. We are committed to providing exceptional service and a memorable dining experience every time.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="conatct-section mt-5 mb-3">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 menu-header-section">
                <div class="footer-side-list">
                    <ul>
                        <li><i class='bx bxs-phone'></i> <a href="tel:{{phone}}">{{phone}}</a></li>
                        <li><i class='bx bxs-envelope'></i> <a href="mailto:{{email}}">{{email}}</a></li>
                        <li><i class='bx bxs-map'></i> <a href="https://maps.app.goo.gl/6xRRnn1AUrBJtjvf7" target="_blank">{{address}}</a></li>
                        <li>
                            <div>
                                <h3 class="openingHoursTitle"><i class='bx bxs-shopping-bag'></i>  Opening Hours</h3>
                                <p class="openingHours mx-4">"{{working_hours || ''}}"</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 before-img-section position-relative">
                <img src="../../../assets/img/home2/about3.png" class="itemImage" alt="About">
                <p class="contact-paragraph-image">We’re here to help — contact our restaurant anytime</p>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>